import request from '@/utils/request'

// 获取表单信息
export function getFormInfo(formConfigId) {
  return request.get(`/api/examinee/v1/form/${formConfigId}`)
}

// 扫码获取信息
export function getUserInfo(qrcode) {
  return request.get(`/api/examinee/v1/form/QRCode/${qrcode}`)

  // return Promise.resolve({
  //   formConfigId: 'SJPZlGHf08f27f6a6e94f3db0cf335d59f02',
  //   token: '9fd78a84013c158659c2624c3893931f',
  // })
}

export function submitForm(body) {
  const url = `/api/examinee/v1/form`

  return request.post(url, body)
}

// /api/examinee/v1/user/${param.token}
export function getUserInfoByToken(param) {
  return request.get(`/api/examinee/v1/user/${param.token}`)
}

// /api/examinee/v1/form/varietyList
export function getVarietyList() {
  return request.post(`/api/examinee/v1/form/varietyList`)
}

// /api/examinee/v1/form/varietyList
export function getVarietyListByCollegeId(param) {
  return request.post(`/api/examinee/v1/form/varietyList`, param)
}

// /api/examinee/v1/form/varietyList
export function getAreaTree(param) {
  return request.post(`/api/examinee/v1/common/areaTree`, param)
}

// /api/examinee/v2/common/area
export function getAreaList(param) {
  return request.get(`/api/examinee/v2/common/area`, param)
}

// api/examinee/v1/common/cityArea
export function getCityAreaList(param) {
  return request.get(`/api/examinee/v1/common/cityArea`, param)
}